
import WithUniqueId from 'Src/js/mixins/WithUniqueId';
import { Component, Mixins, Prop } from 'vue-property-decorator';

@Component({
	name: 'LookupCheckbox',
})
class LookupCheckbox extends Mixins(WithUniqueId) {

	@Prop({ type: Boolean, required: false })
	readonly disabled: boolean;

	@Prop({ type: String, required: false, default: '' })
	readonly name: string;

	@Prop({ type: Boolean, required: true })
	readonly value: boolean;

	toggle() {
		this.$emit('input', !this.value);
		this.$emit('change', !this.value);
	}

}

export default LookupCheckbox;
